// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7db3abd4","732":"b2f20b5a","977":"f2571fa1"}[chunkId] + ".chunk.js";
};